import { Grid, Image, Skeleton } from "antd";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { H5, P3 } from "../../components/NormalFonts";
import { useGetNewsDetail } from "../../hooks/News/news.hooks";
import useGetTimezone from "../../hooks/Timezone/timezone.hooks";
import { ContentWrapper } from "../../layouts/components";
import styles from "./styles.module.scss";

const NewsDetail: React.FC = () => {
  const { id: paramId } = useParams<{ id: string }>();
  const { formatSmartDate, toLocalTimezone } = useGetTimezone();
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const { t } = useTranslation();

  const getImagePadding = () => {
    if (screens.md) return "0 116px";
    if (screens.sm) return "0 64px";
    return "0"; // Default for xs or smaller
  };

  const { data: news, isFetching: isFetchingNews } = useGetNewsDetail(
    { id: paramId },
    {
      enabled: !!paramId,
    }
  );

  return (
    <ContentWrapper>
      <div className={styles.newsWrapper} style={{ gap: screens.sm ? 38 : 28 }}>
        {isFetchingNews ? (
          <Skeleton />
        ) : (
          <>
            <div className={styles.titleWrapper}>
              <H5
                style={{ fontSize: screens.md ? 28 : 20 }}
                weight="medium"
                color="#000"
              >
                {news?.title}
              </H5>
              <P3 color="var(--text-content-3)">
                {news?.start_date
                  ? formatSmartDate(toLocalTimezone(news?.start_date))
                  : ""}
              </P3>
            </div>
            <div
              className={styles.imageContainer}
              style={{ padding: getImagePadding() }}
            >
              <Image
                width={"100%"}
                height={"auto"}
                preview={false}
                src={news?.image_url}
                className={styles.image}
              />
            </div>
            <div
              className={styles.content}
              style={{ fontSize: screens.md ? 20 : 16 }}
              dangerouslySetInnerHTML={{ __html: news?.content }}
            />
          </>
        )}
      </div>
    </ContentWrapper>
  );
};

export default NewsDetail;
